module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_aomori-61f979b7ecb4e4ea696c87abe1670979.png";